import { useState, FaSearch, FaFileExcel, DataTable, ToastContainer, FaPlusCircle, moment, MdArrowDownward, noDatapng, FaCheck, useParams, toast } from '../../common/common';
import MidViewUsers from '../../middleware/Users/MidViewUsers';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import Navigations from '../../common/useNavigation.js';
import { Modal } from 'react-bootstrap';
import axiosJWT from '../../secureAPI/axiosJWT.js';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { showToast } from '../../Utils/toastUtils.js';
import MidPlans from '../../middleware/plans/MidPlans.jsx';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils.js';

const ViewUsers = () => {
    const { type } = useParams();
    const { navigateAddUser } = Navigations();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { users, userPlan, seacrh, setSearch, filteredUsers, exporttoExcelData, permissionstringdata, lgShow1, handlemodalhide, removeUser, lgShow, setLgShow, Remainuser } = MidViewUsers();

    const { setisLoading } = MidPlans(type);

    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var RegistrationDate = users[0]['RegistrationDate'];
        var EmailAddress = users[0]['EmailAddress'];
        var RegistrationDate = moment(RegistrationDate).format('DD-MMM-YYYY');
        var ActiveUser = users[0]["Status"];
    }

    if (Array.isArray(userPlan) && userPlan.length > 0) {
        var planID = userPlan[0]['plan_id'];
    }
    // console.log({ filteredUsers: filteredUsers });
    const columns = [
        {
            name: "User Name",
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.full_name,
        },
        {
            name: "Email Address",
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.email,
        },
        {
            name: "Mobile Number ",
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => row.mobile,
        },
        {
            name: "User Type",
            style: {
                color: 'black ',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => 'Manager',
        },
        {
            name: "Status",
            style: {
                color: 'black',
                fontSize: '15px',
                fontWeight: '500',
            },
            sortable: true,
            selector: (row) => (
                <span
                    className={`px-3 py-1 rounded-full text-white text-xs font-medium ${row.status === 0 ? 'bg-red-500' : 'bg-green-500'
                        }`}
                >
                    {row.status === 0 ? 'Inactive' : 'Active'}
                </span>
            ),
        },
        {
            name: "Action",
            selector: (row) => <div className='flex flex-col lg:flex-row '>

                {ActiveUser === 1 &&

                    <div className='flex'>
                        <div className="p-2 flex flex-row ">
                            <button className='btn btn-danger  mx-1' onClick={() => removeUser(row.id, 1)} > Remove </button>
                        </div>

                        {Remainuser > 0 && row.status === 0 ? (
                            <div className="p-2 flex flex-row ">
                                <button className='btn btn-primary mx-1' onClick={() => removeUser(row.id, 2)} > Active User </button>
                            </div>
                        ) : null}
                    </div>
                }

                <Modal size="md" show={lgShow1} onHide={() => handlemodalhide()} aria-labelledby="example-modal-sizes-title-lg">
                    <Modal.Body>
                        <div className="relative border-b border-slate-200/60 py-3">
                            <label className=" text-lg"> Add New Sub Category</label>
                            <div className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer" onClick={() => handlemodalhide()}> ESC / Close </div>
                        </div>
                        <div className='p-5'>
                            <form method='POST'>
                                <div className='row'>
                                    <div className="container m-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-2 ">
                                        <table>
                                            <tr>
                                                <td>Pages </td>
                                                <td>ADD</td>
                                                <td>EDIT</td>
                                                <td>DELETE</td>
                                                <td>VIEW</td>
                                            </tr>
                                            <tr>
                                                <td>Manager</td>
                                                {permissionstringdata.map(row => (
                                                    <td style={{ padding: '15px' }}>{row === 'S1' ? <FaCheck /> : row === 'S2' ? <FaCheck /> : row === 'S3' ? <FaCheck /> : row === 'S4' ? <FaCheck /> : null}</td>
                                                ))}
                                            </tr>

                                        </table>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>,
        },

    ]

    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    const planPricePerMonth = 0;
    const userPricePerMonth = 1000;

    const [userss, setUsers] = useState(0);

    // Users increment/decrement
    const handleUserIncrease = () => setUsers((prev) => prev + 1);
    const handleUserDecrease = () => setUsers((prev) => (prev > 0 ? prev - 1 : 0));

    // Calculations
    const usersTotalPerMonth = userss * userPricePerMonth;
    const usersTotalYearly = usersTotalPerMonth * 12;

    const planTotalYearly = planPricePerMonth * 12;
    const subTotal = planTotalYearly + usersTotalYearly;
    const gst = subTotal * 0.18;
    const grandTotal = subTotal + gst;


    async function displayRazorpay() {

        if (grandTotal > 0) {

            // alert('Payment Gatway call');
            const res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

            if (!res) {
                // alert("Razorpay SDK failed to load. Are you online?");
                return;
            }

            // creating a new order
            const result = await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Payment`, { plan_name: "new_user_add", cart_ammount: grandTotal * 100, plan_currency: "INR", check: 2 }, { withCredentials: true });
            // console.log({ result: result });
            if (!result) {
                return;
            }

            const options = {
                key: "rzp_test_HHHXi6bhZ0bIvf", // This is Api key. you will get it from razorpay dashboard > account and settings > API keys
                amount: parseInt(grandTotal * 100),
                currency: "INR", // your 3 letter currency code
                name: username, // project or transaction name
                description: "Test Transaction",
                order_id: result.data.order.id,
                // image: { sidebarLogo }, // your project logo
                handler: function (response) {
                    // console.log("response", response);
                    orderPlace(response, 2, grandTotal); // after payment completes on stripe this function will be called and you can do your stuff
                },
                prefill: {
                    name: username,
                    email: EmailAddress,
                    contact: '852369741',
                },
                notes: {
                    address: "India",
                },
                theme: {
                    color: "#158993",
                },
            };

            const paymentObject = new window.Razorpay(options);
            paymentObject.open();

        }
        else
        {
            showToast("Please Add Users ( + ) " , "error")
        }
    }

    const orderPlace = async (response, check, total) => {
        // console.log(response);
        // console.log(plan);
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/purchasePlan`, { response, check, user_count: userss, grandTotal: total }, { withCredentials: true })
                .then((res) => {
                    if (res.data.success === 1) {
                        StopLoading(setisLoading);
                        setLgShow(false)
                        // console.log(res.data.data);
                        showToast("success ", 'success');

                    }
                    else {
                        StopLoading(setisLoading);
                        setLgShow(false);
                        showToast("Failed to get purchasePlan, please try again later ", 'error');
                    }
                })
                .catch((err) => {
                    if (err.response) {
                        console.error('Server responded with a status:', err.response.status);
                        console.error('Response data:', err.response.data);
                    } else if (err.request) {
                        console.error('No response received:', err.request);
                    } else {
                        console.error('Error setting up request:', err.message);
                    }
                    // toastifn(0, "Something went wrong! Please try again later.");
                });
        } catch (err) {
            // StopLoading(setisLoading);
            showToast("Failed to get purchasePlan, please try again later ", 'error');
        }
    }



    return (
        <div className="md:flex md:flex-row md:w-full">
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} currentplan={planID} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full md:ml-2 md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="grid grid-cols-12">
                    <div className="col-start-1 col-end-13">
                        <div className="p-4">
                            <div className=" text-xl  text-[#1e3a8a] mb-2 ">

                                <h1 className=' text-lg text-theme-color-text font-bold'> Users </h1>
                                <p className=' text-gray-600 text-[16px] '>View detailed information about users. </p>

                            </div>
                            <div className="border-0 flex-row rounded-xl bg-white shadow-xs">
                                <div className=' relative  min-w-0 break-words'>
                                    <div className="w-full">
                                        <div class="w-full">
                                            <div class="flex items-start p-3 mb-4 bg-blue-700  border-[1px] border-l-4 border-blue-500 rounded-lg relative">
                                                <div class="flex-shrink-0 text-white">
                                                    <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" fill="currentcolor" viewBox="0 0 24 24">
                                                        <path fill="none" d="M0 0h24v24H0z" />
                                                        <path d="M12 2a10 10 0 1010 10A10.011 10.011 0 0012 2zm-1 15l-5-5 1.41-1.42L11 14.17l6.59-6.59L19 9z" />
                                                    </svg>
                                                </div>
                                                <div class="ml-3">
                                                    <h2 class="text-lg font-semibold text-white">New User Purchased 🎉</h2>
                                                    <p class="text-white">A new user has successfully completed a purchase.</p>
                                                </div>

                                                {ActiveUser === 1 &&

                                                    <div className='ml-auto flex gap-5'>
                                                        <div class="">
                                                            <button class="bg-white text-blue-600 font-medium px-4 py-2 rounded-lg border border-blue-600 hover:bg-blue-50 transition" onClick={() => { setLgShow(true) }}>
                                                                Buy New User
                                                            </button>
                                                        </div>

                                                        <div className="flex items-center gap-3 bg-white border border-gray-200 rounded-2xl  shadow-md w-fit px-3 py-2">
                                                            <div className="bg-blue-500 text-white w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold">
                                                                {Remainuser}
                                                            </div>
                                                            <span className="text-gray-700 font-semibold text-sm">Remaining Users</span>
                                                        </div>


                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        <div className="flex flex-col lg:flex-row justify-between items-center gap-3">
                                            {/* Search Section */}
                                            <div className="w-full lg:w-auto lg:flex-1">
                                                <div className="relative bg-gray-100 p-2 rounded-md border-2 border-gray-200 w-full">
                                                    <FaSearch className="h-5 w-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" />
                                                    <input
                                                        className="bg-transparent pl-10 focus:outline-none w-full text-sm placeholder-gray-500"
                                                        type="text"
                                                        name="searchbox"
                                                        id="searchbox"
                                                        placeholder="Search records…"
                                                        value={seacrh}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            {/* Buttons Section */}
                                            <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto justify-center lg:justify-end">

                                                {/* Download Excel Button */}
                                                <button
                                                    type="submit"
                                                    className="flex items-center justify-center gap-2 rounded-md px-4 py-2 bg-blue-600 text-white 
                   w-full sm:w-auto text-sm sm:text-base font-semibold"
                                                    onClick={() => exporttoExcelData()}
                                                >
                                                    <FaFileExcel className="h-5 w-5" />
                                                    Download Excel
                                                </button>

                                                {/* Add User Button */}

                                                {ActiveUser === 1 &&
                                                    <button
                                                        type="submit"
                                                        className="flex items-center justify-center gap-2 rounded-md px-4 py-2 bg-button-color text-black 
                   w-full sm:w-auto text-sm sm:text-base font-semibold"
                                                        onClick={navigateAddUser}
                                                    >
                                                        <FaPlusCircle className="h-4 w-4" />
                                                        Add New User
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    {filteredUsers?.length > 0 ?
                                        <DataTable
                                            // title="Categories"
                                            columns={columns}
                                            data={filteredUsers}
                                            // selectableRows
                                            pagination
                                            // selectableRowsComponent={Checkbox} // Pass the function only
                                            //selectableRowsComponentProps={{ inkDisabled: true }} // optionally, pass Material Ui supported props down to our custom checkbox
                                            sortIcon={<MdArrowDownward />} // use a material icon for our sort icon. rdt will rotate the icon 180 degrees for you
                                        />
                                        : <center><img src={noDatapng} height={260} width={260} /> <h1 className='text-lg -translate-y-20 text-gray-300 font-bold'> Opps ! No Data Found </h1></center>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <Modal size="lg" show={lgShow} onHide={() => setLgShow(false)} aria-labelledby="example-modal-sizes-title-lg">
                    <Modal.Body>
                        <div className="relative border-b border-slate-200/60 py-2">
                            <label className=" text-lg"> Add New User</label>
                            <div className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer" onClick={() => setLgShow(false)}> ESC / Close </div>
                        </div>
                        <div className='p-2'>
                            <div className="p-6 w-full border-t-2 border-solid border-t-gray-300">
                                <div className="w-full">
                                    {/* Selected Plan */}


                                    {/* Additional Users */}
                                    <div className="border-b pb-4 mb-6">
                                        <div className="flex justify-between items-center mb-2">
                                            <span className="font-semibold text-gray-800 text-lg">Additional Users ({userss})</span>
                                            <div className="flex items-center gap-2">
                                                <button
                                                    onClick={handleUserDecrease}
                                                    className="bg-gray-200 hover:bg-gray-300 p-2 rounded-full shadow"
                                                >
                                                    <FaMinus />
                                                </button>
                                                <span className="text-lg font-bold w-8 text-center">{userss}</span>
                                                <button
                                                    onClick={handleUserIncrease}
                                                    className="bg-pink-500 hover:bg-pink-600 text-white p-2 rounded-full shadow"
                                                >
                                                    <FaPlus />
                                                </button>
                                            </div>
                                        </div>
                                        <div className="flex justify-between text-gray-700 bg-gray-100 p-3 rounded-lg">
                                            <span>Validity: 12 Months</span>
                                            <span>Per User Per Month: <span className="font-bold">₹{userPricePerMonth}</span></span>
                                            <span>Total: <span className="font-bold">₹{usersTotalYearly.toFixed(2)}</span></span>
                                        </div>
                                    </div>

                                    {/* Summary */}
                                    <div className="space-y-3 text-gray-800 bg-gray-50 p-4 rounded-lg">
                                        <div className="flex justify-between">
                                            <span className="text-gray-600">Sub-Total</span>
                                            <span className="font-semibold">₹{subTotal.toFixed(2)}</span>
                                        </div>
                                        <div className="flex justify-between">
                                            <span className="text-gray-600">GST (18%)</span>
                                            <span className="font-semibold">₹{gst.toFixed(2)}</span>
                                        </div>
                                        <div className="flex justify-between font-bold text-xl border-t pt-3">
                                            <span>Total</span>
                                            <span>₹{grandTotal.toFixed(2)}</span>
                                        </div>
                                    </div>

                                    <div className='flex justify-end
                                                          mt-4'>
                                        <button type="button" className="relative rounded-md group px-3 h-12  flex space-x-2 items-center bg-button-color  hover:bg-button-color "
                                            onClick={displayRazorpay}
                                        >
                                            <span className="relative text-md text-black font-semibold ">Continue to Checkout</span>

                                        </button >
                                    </div>
                                </div>
                            </div>

                        </div>
                    </Modal.Body>
                </Modal>

            </div>
            <ToastContainer />
        </div>


    )
}

export default ViewUsers